export interface AxisScale {
  domain: [number, number];
  ticks: number[];
  step: number;
}

export function calculateAxisScale(values: number[]): AxisScale {
  if (values.length === 0) {
    return {
      domain: [0, 1],
      ticks: [0, 0.25, 0.5, 0.75, 1],
      step: 0.25,
    };
  }

  const min = Math.min(...values);
  const max = Math.max(...values);

  if (min === max) {
    const magnitude = 10 ** Math.floor(Math.log10(Math.abs(min || 1)));
    const step = magnitude / 2;

    const domain: [number, number] = [min - step * 2, max + step * 2];

    const ticks = [];

    for (let value = domain[0]; value <= domain[1] + step / 2; value += step) {
      ticks.push(Number(value.toPrecision(12)));
    }

    return {
      domain,
      ticks,
      step,
    };
  }

  const range = max - min;

  const targetTickCount = 7;
  const roughStep = range / (targetTickCount - 1);

  const exponent = Math.floor(Math.log10(roughStep));
  const magnitude = 10 ** exponent;

  const niceSteps = [1, 2, 2.5, 5, 10];
  const normalized = roughStep / magnitude;

  const niceMultiplier = niceSteps.find((step) => normalized <= step) ?? 10;

  const step = niceMultiplier * magnitude;

  const domainMin = Math.floor(min / step) * step;
  const domainMax = Math.ceil(max / step) * step;

  const ticks: number[] = [];

  for (let value = domainMin; value <= domainMax + step / 2; value += step) {
    ticks.push(Number(value.toPrecision(12)));
  }

  return {
    domain: [domainMin, domainMax],
    ticks,
    step,
  };
}
